import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { message, Modal } from "antd";
import { Input } from "../../src/ui/Input";
import { Card } from "../../src/ui/Card";
import TextField from "../ui/TextField";
import { EyeIcon, EyeOff } from "lucide-react";
import { AuthContext } from "../context/AuthContext";
import axios from "../axios/AxiosInstance";
import { restoreAgency } from "../services/agencyPreference";

export default function LoginPage() {
  const { token } = useParams();
  const { setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [, setCode] = useState("");

  useEffect(() => {
    if (token) {
      axios
        .post("auth/check/freelance/login", { token })
        .then(async (res) => {
          localStorage.setItem("isLogged", "true");
          localStorage.setItem("accessToken", res.data.access_token);
          localStorage.setItem("agencyName", res.data.agencyName);
          localStorage.setItem("agencyCity", res.data.agencyCity || "");
          localStorage.setItem("refreshToken", res.data.refresh_token);
          localStorage.setItem("userEmail", res.data.email);
          localStorage.setItem("userRole", res.data.role);
          localStorage.setItem("userId", res.data._id);
          localStorage.setItem("firstname", res.data.firstname);
          localStorage.setItem("lastname", res.data.lastname);
          if (!(await restoreAgency())) message.warning("Votre dernière agence n’a pas pu être restaurée. Vous pouvez la sélectionner dans le menu.");
          setIsLoggedIn(true);
          navigate("/dashboard"); // ou autre page utile
        })
        .catch((e) => {
          console.log("Token invalide");
          message.error("Token invalide");
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = (e) => {
    e.preventDefault();
    console.log("login");
    axios
      .post("/auth/freelance/login", { username: email, password })
      .then(async (res) => {
        localStorage.setItem("isLogged", true);
        localStorage.setItem("accessToken", res.data.access_token);
        localStorage.setItem("agencyName", res.data.agencyName);
        localStorage.setItem("agencyCity", res.data.agencyCity || "");
        localStorage.setItem("refreshToken", res.data.refresh_token);
        localStorage.setItem("userEmail", res.data.username);
        localStorage.setItem("userRole", res.data.role);
        localStorage.setItem("userId", res.data._id);
        localStorage.setItem("firstname", res.data.firstname);
        localStorage.setItem("lastname", res.data.lastname);
        localStorage.setItem("phone", res.data.phone);

        console.log(res.data);
        if (!(await restoreAgency())) message.warning("Votre dernière agence n’a pas pu être restaurée. Vous pouvez la sélectionner dans le menu.");
        setIsLoggedIn(true);
        navigate("/dashboard");
      })
      .catch((e) => {
        console.log(e);
        message.error("username ou  mot de passe erroné");

        alert("username ou  mot de passe erroné");
      });
  };

  // const selectCode = (code, event) => {
  //   setCode(code)
  //   if (event.key === 'Enter') {
  //     validateCode()
  //   }
  // }

  // const validateCode = () => {
  //   axios
  //     .post('auth/validate-code', { username, code })
  //     .then((res) => {
  //       console.log(res)
  //       localStorage.setItem('isLogged', true)
  //       localStorage.setItem('accessToken', res.data.access_token)
  //       localStorage.setItem('agency', res.data.agency)
  //       localStorage.setItem('refreshToken', res.data.refresh_token)
  //       localStorage.setItem('userEmail', res.data.email)
  //       localStorage.setItem('userRole', res.data.role)
  //       localStorage.setItem('name', res.data.name.split(' ')[0])
  //       localStorage.setItem('userId', res.data._id)
  //       setIsLoggedIn(true)
  //       navigate('/')
  //     })
  //     .catch((e) => {
  //       message.error('code invalide !')
  //       setCode('')
  //     })
  // }

  // const handleLogin = (e) => {
  //   e.preventDefault()

  //   axios
  //     .post('/auth/login', { username, password })
  //     .then((res) => {
  //       setOpenModal(true)
  //     })
  //     .catch((e) => {
  //       message.error('username ou  mot de passe erroné')
  //       console.log(e)
  //     })
  // }

  /*  const handleLogin = async (e) => {
      e.preventDefault();
      setLoading(true);
  
      try {
        // Simuler une connexion réussie
        setTimeout(() => {
          // Redirection vers le dashboard après connexion réussie
          navigate("/dashboard");
          
          // Notification de bienvenue
          addNotification({
            type: "system",
            title: "Connexion réussie",
            message: "Bienvenue sur J'M Intérim. Vous êtes maintenant connecté."
          });
        }, 1000);
      } catch (error) {
        console.error("Erreur de connexion", error);
      } finally {
        setLoading(false);
      }
    };
   */
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-tr from-gray-50 to-gray-100 p-4">
      {openModal && (
        <Modal
          centered
          className="w-[600px] rounded-2xl bg-gray-200"
          open={openModal}
          footer={null}
          onCancel={() => setOpenModal(false)}
        >
          <div className="flex  mt-6  rounded-lg  flex-col h-48 space-y-4 items-center justify-center">
            <div className="flex flex-col items-center">
              <p className="mt-4 text-lg">
                Entrez le code à 6 chiffres reçu par email
              </p>
            </div>
            <Input
              //value={code.length ? code : null}
              onChange={(e) => setCode(e.target.value)}
              // onKeyDown={(e) => selectCode(e.target.value, e)}
              placeholder="code de validation"
              className="h-12 pl-10 border-gray-200  rounded-xl w-2/4 bg-white focus:border-gray-400 focus:ring focus:ring-gray-300 focus:ring-opacity-50"
            />
            <button
              // onClick={validateCode}
              className="rounded-md border p-2 text-white font-semibold bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 w-2/4"
            >
              Valider
            </button>
          </div>
        </Modal>
      )}
      <div className="w-full max-w-5xl flex rounded-3xl overflow-hidden shadow-xl">
        {/* Partie gauche - Formulaire de connexion */}
        <div className="w-full lg:w-2/5 bg-gray-50 p-10 flex flex-col justify-center">
          <div className="text-center mb-10">
            <h1 className="text-3xl font-semibold text-gray-700 mb-4">
              J'M <span className="text-gray-600">INTERIM</span>
            </h1>
          </div>

          <Card className="border-none shadow-none bg-transparent">
            <form className="space-y-6">
              <div className="space-y-2">
                <div className="relative">
                  <TextField
                    name="email"
                    className="text-blue-500"
                    onChange={(e) => setEmail(e.target.value)}
                    aria-label="Input name"
                    type="email"
                    placeholder="Identifiant"
                    icon="bi:envelope-open"
                    width={14}
                  />
                  <div className="absolute left-3 top-3.5 text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <div className="relative">
                  <TextField
                    name="password"
                    className="text-blue-500"
                    onChange={(e) => setPassword(e.target.value)}
                    arial-label="Input password"
                    type={isVisible ? "text" : "password"}
                    onClick={() => setIsVisible(!isVisible)}
                    icon_psw={
                      isVisible
                        ? "mdi:EyeIcon-outline"
                        : "mdi:EyeIcon-off-outline"
                    }
                    placeholder="Mot de passe"
                    icon={"ri:lock-2-line"}
                    // width={17}
                  />
                  <div className="absolute left-3 top-3.5 text-gray-400">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <button
                    type="button"
                    className="absolute right-3 top-3 text-gray-400 hover:text-gray-600"
                  >
                    {isVisible ? (
                      <EyeIcon
                        className="h-5 w-5"
                        onClick={() => setIsVisible(false)}
                      />
                    ) : (
                      <EyeOff
                        className="h-5 w-5"
                        onClick={() => setIsVisible(true)}
                      />
                    )}
                  </button>
                </div>
              </div>

              <button
                onClick={login}
                className="w-full h-12 bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900 text-white rounded-xl"
              >
                Connexion
              </button>

              <div className="text-center">
                <a
                  href="/forgot-password"
                  className="text-sm text-gray-500 hover:text-gray-700"
                >
                  Mot de passe oublié ?
                </a>
              </div>
            </form>
          </Card>
        </div>

        {/* Partie droite - Slogan */}
        <div className="hidden lg:block lg:w-3/5 bg-gradient-to-br from-gray-800 to-gray-900 relative overflow-hidden">
          <div className="h-full flex flex-col items-center justify-center p-10 text-center">
            <div className="relative max-w-xl">
              <div className="text-white text-3xl font-light leading-tight tracking-wide mb-6">
                <span className=" mb-4">Derrière chaque réussite,</span>
                <p className="flex space-x-1 justify-center">
                  <span>une équipe</span>
                  <span className=" text-white font-semibold mr-1">
                    J'm intérim
                  </span>
                </p>
                <span className=" text-gray-300 mt-4">engagée !</span>
              </div>

              <div className="w-32 h-1 mx-auto bg-gradient-to-r from-gray-300 to-gray-400 opacity-60 mb-10"></div>

              {/*    <div className="text-gray-400 italic text-lg md:text-xl">
                  Votre partenaire de confiance pour l'emploi temporaire
                </div> */}
            </div>

            {/* Décoration géométrique */}
            <div className="absolute -bottom-10 -right-10 w-40 h-40 border-[16px] border-gray-700 rounded-full opacity-30"></div>
            <div className="absolute -top-10 -left-10 w-40 h-40 border-[16px] border-gray-700 rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
